import { memo, useState } from "react";
import { Grid2, Typography, Link, InputAdornment } from "@mui/material";
import { useNavigate } from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import useAuthenticationStyles from "../components/styles/Authentication.js";
import { Image } from "mui-image";
import { useSnackbar } from "../utils/index.js";
import Spinner from "../components/Spinner.js";
import { resetPassword } from "../api/index.js";
import Form from "../components/Form.js";
import logo from "../assets/images/logo-white-first.png";

const ResetPassword = () => {
	const queryString = window.location.search;
	const urlParams = new URLSearchParams(queryString);
	const token = urlParams.get("token");
	const [isSubmitting, setIsSubmitting] = useState(false);
	const classes = useAuthenticationStyles();
	const { success, error } = useSnackbar();
	const navigate = useNavigate();

	const [showPassword, setShowPassword] = useState(false);

	const handleShowPassword = () => {
		setShowPassword(!showPassword);
	};

	const submitHandler = async (values) => {
		setIsSubmitting(true);

		try {
			const { success: successCode, message } = await resetPassword(values.password, token);

			if (successCode) {
				success(message);
				navigate("/");
			} else {
				error(message);
			}
		} catch (error_) {
			console.log(error_);
		}
		setIsSubmitting(false);
	};

	const formContent = [
		{
			customType: "input",
			id: "password",
			type: showPassword ? "text" : "password",
			placeholder: "Νέος κωδικός",
			variant: "filled",
			inputProps: {
				endAdornment: (
					<InputAdornment position="start">
						<IconButton
							aria-label="toggle password visibility"
							tabIndex={-1}
							onClick={handleShowPassword}
						>
							{showPassword ? <Visibility /> : <VisibilityOff />}
						</IconButton>
					</InputAdornment>
				),
			},
		},
		{
			customType: "input",
			id: "confirmPassword",
			type: showPassword ? "text" : "password",
			placeholder: "Επανάληψη κωδικού",
			variant: "filled",
			inputProps: {
				endAdornment: (
					<InputAdornment position="start">
						<IconButton
							aria-label="toggle password visibility"
							tabIndex={-1}
							onClick={handleShowPassword}
						>
							{showPassword ? <Visibility /> : <VisibilityOff />}
						</IconButton>
					</InputAdornment>
				),
			},
		},
		{
			customType: "button",
			id: "submit",
			type: "submit",
			text: "Αλλαγή Κωδικού",
		},
	];

	return (
		<>
			<Spinner open={isSubmitting} />
			<Grid2 container direction="row" justifyContent="center" align="center" className={classes.root}>
				<Grid2 item container direction="column" justifyContent="center" align="center" sm={5} xs={12} sx={{ "> .MuiGrid-item": { p: 1 } }}>
					<Grid2 item mb={3}>
						<Image src={logo} alt="Logo" className={classes.logo} />
					</Grid2>
					<Grid2 item mt={2}>
						<Typography variant="h4" className={classes.title} sx={{ color: "secondary.main" }}>{"Επαναφορά Κωδικού"}</Typography>
					</Grid2>
					<Grid2 item container direction="column" justifyContent="center" alignItems="center">
						<Form content={formContent} validationSchema="resetPasswordSchema" onSubmit={submitHandler} />
					</Grid2>
					<Grid2 item container direction="column" justifyContent="center" alignItems="space-between">
						<Grid2 item>
							<Typography variant="h7" color="white.main">{"Αλλιώς, "}</Typography>
							<Typography variant="h7" className={classes.subtitle}>
								<Link color="inherit" underline="none" href="/">{"Συνδεθείτε"}</Link>
							</Typography>
						</Grid2>
					</Grid2>
				</Grid2>
			</Grid2>
		</>
	);
};

export default memo(ResetPassword);
